export const MenuArrowSmall = ({ style, className }) => {
    return (
      <svg
        style={style}
        className={className}
        width="16" 
        height="16" 
        viewBox="0 0 16 16"
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 12L6 8L10 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  };